// extracted by mini-css-extract-plugin
module.exports = {"full":"Banner-module--full--A1Sqv","desktop":"Banner-module--desktop--1imM7","mobile":"Banner-module--mobile--3QrxL"};